import { render, staticRenderFns } from "./IconSvgPpt.vue?vue&type=template&id=914ca854&scoped=true&"
import script from "./IconSvgPpt.vue?vue&type=script&lang=js&"
export * from "./IconSvgPpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914ca854",
  null
  
)

export default component.exports